<template>
    <div id="image-text-element" :class="{empty: !moduleData}">
        <div class="module" v-if="moduleData" :class="moduleData.Background + ' ' + moduleData.Spacing" :id="moduleData.AnchorID">
            <div class="container" :class="[moduleData.ContentPosition, moduleData.Watermark.ID ? 'even-split' : '']">
                <div class="image-holder">
                    <b-img-lazy v-if="moduleData.Image && moduleData.Image.ID" class="shadow-heavy" v-bind="imageProps" :src="moduleData.Image.URL"
                                @load.native="imageLoaded = true"
                                :class="{loaded: imageLoaded}"></b-img-lazy>
                </div>
                <b-img class="watermark" v-if="moduleData.Watermark && moduleData.Watermark.ID" :src="moduleData.Watermark.URL"></b-img>
                <div class="content-holder" v-if="imageLoaded">
                    <div class="wrapper">
                        <h2 v-if="moduleData.Title && moduleData.ShowTitle">{{moduleData.Title}}</h2>
                        <p v-if="moduleData.SummaryText" class="summary" v-html="moduleData.SummaryText"></p>
                        <p v-if="moduleData.Content" v-html="moduleData.Content"></p>
                        <div class="action">
                            <a class="btn btn-dark shadow-heavy" v-if="moduleData.CTA && moduleData.CTA.ID" :href="moduleData.CTA.URL">{{moduleData.CTA.CTAText}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "ImageTextElement",
        data() {
            return {
                imageProps: {
                    center: true,
                    fluidGrow: true,
                    blank: true,
                    blankColor: '#fff'
                },
                imageLoaded: false
            }
        },
        props: {
            component: {
                type: Object,
            }
        },
        computed: {
            ...mapGetters(['getModuleData', 'getSettings']),
            moduleData() {
                return this.getModuleData(this.component.ID);
            }
        }
    }
</script>
